module.exports = __webpack_public_path__ + "img/player-heart-outline-icon.580a071c.svg";